
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { FulfillmentColumn as FulfillmentColumnType, Fulfillment } from '@/types/fulfillment';
import FulfillmentCard from './FulfillmentCard';
import { ScrollArea } from '@/components/ui/scroll-area';

interface FulfillmentColumnProps {
  column: FulfillmentColumnType;
  onProjectClick: (project: Fulfillment) => void;
}

const FulfillmentColumn = ({ column, onProjectClick }: FulfillmentColumnProps) => {
  const { setNodeRef } = useDroppable({
    id: column.id,
    data: {
      type: 'column',
      columnId: column.id
    }
  });
  
  // Log when the column renders with new data
  React.useEffect(() => {
    console.log(`[FulfillmentColumn] ${column.title} rendered with ${column.projects.length} projects`);
  }, [column.title, column.projects.length]);

  return (
    <div className="flex flex-col h-full min-w-[280px] max-w-[280px]">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-medium text-md">{column.title}</h3>
        <div className="bg-gray-100 dark:bg-gray-700 rounded-full px-2 py-0.5 text-xs">
          {column.projects.length}
        </div>
      </div>
      
      <div
        ref={setNodeRef}
        className="flex-1 bg-gray-50/50 dark:bg-slate-900/50 rounded-lg border border-gray-200/50 dark:border-gray-700/50 h-[calc(100vh-280px)]"
        data-column-id={column.id}
      >
        <ScrollArea className="h-full p-2">
          <SortableContext
            items={column.projects.map(project => project.id)}
            strategy={verticalListSortingStrategy}
          >
            {column.projects.map((project) => (
              <FulfillmentCard
                key={project.id}
                project={project}
                onClick={onProjectClick}
                columnId={column.id}
              />
            ))}
            
            {column.projects.length === 0 && (
              <div className="flex flex-col items-center justify-center h-24 text-gray-400 dark:text-gray-500 text-sm border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-md">
                <p>Drop projects here</p>
              </div>
            )}
          </SortableContext>
        </ScrollArea>
      </div>
    </div>
  );
};

export default FulfillmentColumn;
